import { createSlice } from "@reduxjs/toolkit";

const order = createSlice({
	name: "order",
	initialState: {
		isSocketConnected: false,
    	socket: null,
		orderList: [],
		orderReviewFromOtherUser: [],
		orderReviewFromThisUser: [],
		otherUserGiveReview: false,
		thisUserGiveReview: false,
    	canSeeGiveRatingAndReview: false,
    	canSeeGiveRatingAndReviewSection: false,
	},
	reducers: {
		orderListValue: (state, action) => {
			state.orderList = action.payload.orderValue
		},
		orderReviewFromOtherUserValue: (state, action) => {
			state.orderReviewFromOtherUser = action.payload.orderReviewFromOtherUser
		},
		orderReviewFromThisUserValue: (state, action) => {
			state.orderReviewFromThisUser = action.payload.orderReviewFromThisUser
		},
	    canSeeGiveRatingAndReviewValue: (state, action) => {
	      state.canSeeGiveRatingAndReview = action.payload.canSeeGiveRatingAndReview;
	    },
	    otherUserGiveReviewValue: (state, action) => {
	      state.otherUserGiveReview = action.payload.otherUserGiveReview;
	    },
	    thisUserGiveReviewValue: (state, action) => {
	      state.thisUserGiveReview = action.payload.thisUserGiveReview;
	    },
	    canSeeGiveRatingAndReviewSectionValue: (state, action) => {
	      state.canSeeGiveRatingAndReviewSection = action.payload.canSeeGiveRatingAndReviewSection;
	    },
		connectOrderSocket: (state, action) => {
			state.isSocketConnected = true;
			state.socket = action.payload;
		  },
		disConnectOrderSocket: (state, action) => {
			state.isSocketConnected = false;
			state.socket = null;
		},
	}
})


export const { 
	orderListValue, 
	canSeeGiveRatingAndReviewValue, 
	orderReviewFromOtherUserValue, 
	orderReviewFromThisUserValue, 
	otherUserGiveReviewValue, 
	thisUserGiveReviewValue, 
	canSeeGiveRatingAndReviewSectionValue,
	connectOrderSocket,
	disConnectOrderSocket
} = order.actions;

export default order.reducer;